<template>
    <section id="login-form" class="container">
        <div class="row">
            <div class="col-md-10">
                <h2>Reset your password</h2>
                <p>Type the email you used to sign up and hit the 'reset your password' button.</p>
                <p>We'll send you an email with instructions on how to set a new one up.</p>
                <form class="my-3">
                    <div class="form-row">
                        <TextInput
                            inputId="resetCode"
                            v-model="formData.resetCode"
                            labelText="Reset code"
                            helpText="You should have received an email with this code."
                            :wrapperClasses="['col-md-6']"
                        />
                    </div>
                    <div class="form-row">
                        <TextInput
                            inputId="password"
                            v-model="formData.password"
                            labelText="Password"
                            autocomplete="new-password"
                            :password="true"
                            :helpText="'At least 8 characters in length and must contain at least one of each of these characters: uppercase, lowercase, symbol, number'"
                            :wrapperClasses="['col-md-6']"
                        />
                    </div>
                    <div class="form-row">
                        <TextInput
                            inputId="passwordConfirm"
                            v-model="formData.passwordConfirm"
                            labelText="Confirm password"
                            :password="true"
                            autocomplete="new-password"
                            :validation="password ? [{type:'match',value:formData.password,msg:'Your passwords don\'t match'}] : []"
                            :wrapperClasses="['col-md-6']"
                        />
                    </div>

                    <button
                        class="btn-mobile btn btn-primary"
                        type="submit"
                        @click.prevent="resetPassword"
                    >Reset your password</button>
                    <div class="spinner-container" v-if="loading">
                        <div class="spinner"></div>
                    </div>
                </form>
                <div class="new-account">
                    <div class="new-account__header">Don't have an account yet?</div>
                    <router-link to="/create-account">Create an account</router-link>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import TextInput from "@/components/inputs/TextInput";

export default {
    name: "reset-password-form",
    components: {
        TextInput
    },
    data() {
        return {
            formData: {
                password: "",
                passwordConfirm: "",
                resetCode: ""
            },
            submitted: false,
            errors: [],
            loading: false
        };
    },
    computed: {
        error() {
            // are there trues in the error list
            const errors = this.errors.filter(error => {
                return error.hasError == true;
            });
            const error = errors.length > 0 ? true : false;
            return error;
        },
        stamp() {
            if (this.$route.query.stamp) {
                return encodeURI(this.$route.query.stamp).replace(
                    new RegExp(/%20/gi),
                    "+"
                );
            }
            return null;
        },
        el() {
            if (this.$route.query.el) {
                return encodeURI(this.$route.query.el).replace(
                    new RegExp(/%20/gi),
                    "+"
                );
            }
            return null;
        },
        token() {
            if (this.$route.query.token) {
                return encodeURI(this.$route.query.token).replace(
                    new RegExp(/%20/gi),
                    "+"
                );
            }
            return null;
        }
    },
    methods: {
        resetPassword() {
            // Reset the password then direct to login
            this.loading = true;
            const resetInfo = {
                token: this.token,
                stamp: this.stamp,
                ResetCode: this.formData.resetCode,
                Password_Old: "",
                Password: this.formData.password,
                PasswordConfirm: this.formData.passwordConfirm,
                Email: this.el
            };

            const data = JSON.stringify(resetInfo);

            this.$store
                .dispatch("AUTH_PASSWORD_RESET_CODE", data)
                .then(resp => {
                    if (resp == "success") {
                        this.loading = false;
                        this.$emit("success");
                    } else {
                        this.loading = false;
                        this.$emit("fail", resp);
                    }
                });
        }
    },
    created() {
        const resetInfo = `?token=${this.token}&stamp=${this.stamp}`;

        this.$store
            .dispatch("AUTH_PASSWORD_RESET_CHECK", resetInfo)
            .then(resp => {
                if (resp == "success") {
                    this.loading = false;
                } else {
                    this.loading = false;
                    this.$emit("expired");
                }
            });
    }
};
</script>